import { render } from "./ProblemQuickCreateModal.vue?vue&type=template&id=5e7f1844&scoped=true"
import script from "./ProblemQuickCreateModal.vue?vue&type=script&lang=js"
export * from "./ProblemQuickCreateModal.vue?vue&type=script&lang=js"

import "./ProblemQuickCreateModal.vue?vue&type=style&index=0&id=5e7f1844&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1910356388/src/ilongevity-backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7f1844"]])

export default __exports__